<script>
export default {
	name: 'ScriptExecutor',
	inheritAttrs: false,
};
</script>

<script setup>
import { isMobileViewport } from '~/logic/composables/breakpoints.js';

const props = defineProps({
	description: { type: String, default: '' },
	isHideInDesktop: { type: Boolean, default: false },
	isHideInMobile: { type: Boolean, default: false },
});

onMounted(() => {
	if (!document.querySelector('.script-executor-container')) {
		return;
	}
	const htmlCode = props.description;
	const parser = new DOMParser();
	const doc = parser.parseFromString(htmlCode, 'text/html');
	document.querySelector('.script-executor-container').innerHTML += doc.body.innerHTML;
	const scriptTags = doc.querySelectorAll('script');
	const styleTags = doc.querySelectorAll('style');
	styleTags.forEach((style) => {
		const newStyle = document.createElement('style');
		newStyle.textContent = style.textContent;
		document.body.appendChild(newStyle);
	});
	scriptTags.forEach((script) => {
		const newScript = document.createElement('script');
		newScript.type = script.type;
		if (script.src !== '') {
			newScript.src = script.src;
		}
		newScript.textContent = script.textContent;
		document.body.appendChild(newScript);
	});
});


</script>

<template>

<div
	v-if="(isMobileViewport && !props.isHideInMobile) || (!isMobileViewport && !props.isHideInDesktop)"
	class="script-executor-container"
>
</div>

</template>